// Remodal
$(function() {
  $('[data-remodal-id]').remodal();
});



// WEBPACK FOOTER //
// G:/RABOTA/lekar/dev/source/modules/modal/modal.js